import {h, Fragment, Component} from "preact";
import {route} from "preact-router";
import LFeed from "../../../services/live-feed";
import Page from "../../../services/page-data-feed";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as T from "../mobile-templates/tournament.jsx";
import {StatsIconRegular} from "../utils/icons";
import {Statsbox} from "../desktop-pages/live";

export default class LiveMenuSide extends Component {
	state = {
		sports: null
	}
	componentWillMount() {
		LFeed.onUpdate(this.handle = () => {
			this.setState({})
		})
	}
	componentDidUnmount() {
		LFeed.stopUpdate(this.handle);
	}
	render() {
		const sports = LFeed.menu;
		if (sports == null)
			return null;
		return <div>
			{Object.values(sports).sort((a, b) => a.order - b.order).map(sport => (
				<SportRow key={sport.id} sport={sport} />
			))}
		</div>
	}
}

export class SportRow extends Component {
	state = {
		open: true,
		wasOpen: true,
		checked: [],
		showstats: {}
	};

	toggleEventStats(event) {
		if (!!this.state.showstats[event.id]) {
			delete this.state.showstats[event.id];
		} else {
			this.state.showstats[event.id] = true;
		}

		this.setState({});
	}

	isStatsVisible(event) {
		return !!this.state.showstats[event.id];
	}

	render({sport}) {
		return <div>
			<M.SportButton onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
			  <div class="pl-2"><M.SportFlagIcon sport={sport} /></div>
			  <M.LeagueNameLabel>{sport.name}</M.LeagueNameLabel>
			  <div class="px-2">
				  <M.MenuMatchCounter>{sport.count}</M.MenuMatchCounter>
			  </div>
			</M.SportButton>
			{this.state.open && <div>
				{Object.values(sport.sub).sort((a, b) => a.order - b.order).map(tournament => {
					return <TournamentRow tournament={tournament} isStatsVisible={this.isStatsVisible.bind(this)} toggleEventStats={this.toggleEventStats.bind(this)} />
				})}
			</div>}
		  </div>
	}
}

function TournamentRow({tournament, isStatsVisible, toggleEventStats}) {
	return <div>
		<T.TournamentHeaderRow>
			<T.TournamentRowContent>
				<M.RegionFlagSmall category={{label: tournament.label.split(' - ')[0]}} />
				<T.TournamentName>{tournament.name}</T.TournamentName>
			</T.TournamentRowContent>
		</T.TournamentHeaderRow>
		{Object.values(tournament.sub).sort((a, b) => a.date - b.date).map(event => (
			<T.FixedMatchRow active={window.location.pathname == '/live'+event.id}>
				<T.MatchInfoWithVisibleOverflow
					key={event.id} 
					onClick={() => {route('/live'+event.id, null)}}
					active={window.location.pathname == '/live'+event.id}>
					<T.Teams>
						<T.TeamWithScore>
							<T.HomeTeamName>{event.home}</T.HomeTeamName>
							<T.ScoreElement>{event.current.result[0]}</T.ScoreElement>
						</T.TeamWithScore>
						<T.TeamWithScore>
							<T.AwayTeamName>{event.away}</T.AwayTeamName>
							<T.ScoreElement>{event.current.result[1]}</T.ScoreElement>
						</T.TeamWithScore>
					</T.Teams>
					<div class="flex items-center justify-start relative">
						<div class="w-full">
							<T.MatchTime>{event.status.phase}{event.status.timer ? ' - ' + event.status.timer + "'" : ''}</T.MatchTime>
						</div>
						<div>
							{event.sport === '/sport/1'
							  ? <a href="javascript:void(0);" onClick={e => {e.stopPropagation(); toggleEventStats(event);}}>
									<StatsIconRegular class="h-3" />
								</a>
							  : null}
							{isStatsVisible(event)
								? <div class="relative">{<Statsbox event={event} onClose={() => toggleEventStats(event)} />}</div>
								: null}
						</div>
					</div>
				</T.MatchInfoWithVisibleOverflow>
			</T.FixedMatchRow>
		))}
	</div>
}